<template>
  <Modal
		class="personas long-modal"
	 	width="1000"
		v-model="show"
    :loading="loading"
		@on-ok="ok"
  	@on-cancel="cancel"
	>
    <div slot="header" class="modal-header " >修改客户画像</div>
		<Tabs type="card">
			<Tab-pane label="客户信息">
				<h4>基础信息</h4>
				<Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
					<Row>
						<Col span="7">
							<FormItem label="姓名" prop="realName">
            		<Input :disabled="formData.isRegister!=1" placeholder="请输入" v-model="formData.realName" ></Input>
							</FormItem>
						</Col>
						<Col span="7">
							<FormItem label="电话" prop="customerMobile">
            		<Input  :disabled="formData.isRegister!=1" placeholder="请输入" v-model="formData.customerMobile" ></Input>
							</FormItem>
						</Col>
						<Col span="7">
							<FormItem label="性别" prop="customerSex">
								<Select  :disabled="formData.isRegister!=1" v-model="formData.customerSex">
									<Option :value="1">女</Option>
									<Option :value="2">男</Option>
								</Select>
							</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="4">
							<FormItem label="证件信息" prop="idType">
								<Select  :disabled="formData.isRegister!=1" style="float:left" v-model="formData.idType">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in idTypeList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
						<Col span="3">
							<!-- <FormItem prop="idNo"> -->
								<Input :disabled="formData.isRegister!=1"  v-model="formData.idNo"></Input>
							<!-- </FormItem> -->
						</Col>
						<Col span="7">
							<FormItem label="出生年月" prop="customerBirthday">
								<DatePicker :disabled="formData.isRegister!=1" style="width:100%" v-model="customerBirthday"  split-panels  format="yyyy-MM-dd" placeholder="出生年月"></DatePicker>
							</FormItem>
						</Col>
						<Col span="7">
							<FormItem label="年龄" prop="name">
								<span v-if="age">{{age}}</span>
							</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="7">
							<FormItem  label="国籍" prop="nationCode">
								<Select :disabled="formData.isRegister!=1"  v-model="formData.nationCode" @on-change="getJiguan">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in nationList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
						<Col span="7">
							<FormItem label="籍贯" prop="provinceCode">
								<Select  :disabled="formData.isRegister!=1" v-model="formData.provinceCode">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in jiguanList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
						<Col span="7">
							<FormItem label="学历" prop="customerEdu">
								<Select  :disabled="formData.isRegister!=1" v-model="formData.customerEdu">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in customerEduList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
							</FormItem>
						</Col>
					</Row>
				</Form>
				<Form :model="formData" :label-width="110" >
					<h4>客户动态</h4>
					<Row :gutter="10">
						<Col span="10">
							<FormItem label="当前状态" prop="currentStatus">
								<Select style="float:left" :class="['width210',{'width80':formData.currentStatus==99}]" v-model="formData.currentStatus">
									<Option  value="">请选择</Option>
									<Option v-for="(item,index) in currentStatusList" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<Col span="4" style="width:130px" v-if="formData.currentStatus == 99">
									<Input placeholder="请填写当前状态" v-model="formData.currentStatusMsg" ></Input>
								</Col>
								<Tooltip v-if="logList.currentStatus" class="tip" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.currentStatus" :key="index">
										{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>

						<Col span="12">
							<FormItem label="工作地点" prop="workAddressArr" >
                <div style="display: inline-block;width: 290px;">                <location ref="workaddress" :id="'updatework'"></location>
                </div>

                <!--           			<Cascader style="width:210px;float:left;margin-right:5px" :data="regionList" trigger="hover" v-model="formData.workAddressArr"></Cascader>-->
								 <Tooltip v-if="logList.workAddress" class="tip " placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.workAddress" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>
						<!-- <Col span="4" v-if="formData.workAddress == 99">
							<Input placeholder="请填写" v-model="formData.workAddress" ></Input>
						</Col> -->
					</Row>
					<Row :gutter="10">
						<Col span="10">
							<FormItem label="机构名称" prop="originalName">
								<Input style="width:210px" placeholder="请填写机构名称" v-model="formData.originalName" ></Input>
								<Tooltip v-if="logList.originalName" class="tip" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.originalName" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>
						<Col span="10">
							<FormItem label="薪资范围" prop="salaryRange">
								<Select style="width:174px;margin-right:10px;float:left" v-model="formData.salaryRange" class="item-width">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in salaryRangeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select><span style="float:left">元/月</span>
								<Tooltip v-if="logList.salaryRange" style="height:30px;display:inline-block;width:50px;margin-left:5px;float:left" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.salaryRange" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>
					</Row>
					<Row :gutter="10">
						<Col span="10">
							<FormItem label="获知自如寓渠道" prop="channel">
								<Select style="float:left" :class="['width210',{'width80':formData.channel==99}]" v-model="formData.channel">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in channelList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<Col span="4" style="width:130px" v-if="formData.channel == 99">
									<Input placeholder="请填写获知渠道" v-model="formData.channelMsg" ></Input>
								</Col>
								<Tooltip v-if="logList.channel" class="tip" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.channel" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>

						<Col span="10">
							<FormItem label="自如寓印象" prop="impression">
								<Select style="float:left" :class="['width210',{'width80':formData.impression==99}]" v-model="formData.impression">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in impressionList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<Col span="4" style="width:130px" v-if="formData.impression==99">
									<Input placeholder="请填写对自如寓的印象" v-model="formData.impressionMsg" ></Input>
								</Col>
								<Tooltip v-if="logList.impression" class="tip" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.impression" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>

					</Row>

          <Row :gutter="10">
            <Col span="10">
              <FormItem label="行业/方向">
                <Cascader class="width210" :data="jobTrade" v-model="jobTradedata"></Cascader>
<!--                <Select style="float:left" :class="['width210',{'width80':formData.channel==99}]" v-model="formData.channel">-->
<!--                  <Option value="">请选择</Option>-->
<!--                  <Option v-for="(item,index) in channelList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>-->
<!--                </Select>-->
              </FormItem>
            </Col>


          </Row>
					<h4>找房要求</h4>
					<Row  :gutter="10">
						<Col span="10">
							<FormItem label="期望入住时间" prop="intentionInTime">
								<DatePicker style="width:210px"  v-model="formData.intentionInTime"  split-panels  format="yyyy-MM-dd" placeholder="期望入住时间"></DatePicker>
								<!-- <Tooltip v-if="logList.intentionInTime" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.intentionInTime" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip> -->
							</FormItem>
						</Col>
						<Col span="10">
							<FormItem label="预算范围" prop="budgetRange">
								<Select style="width:174px;margin-right:10px;float:left" v-model="formData.budgetRange" class="item-width">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in budgetRangeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<span style="float:left">元/月</span>
								<Tooltip v-if="logList.budgetRange" style="height:30px;display:inline-block;width:50px;margin-left:5px;float:left" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.budgetRange" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
							</FormItem>
						</Col>
					</Row>
					<Row  :gutter="10">
						<Col span="10">
							<FormItem label="几人居住" prop="checkinNum">
								<Select style="width:210px;float:left" v-model="formData.checkinNum" class="item-width">
									<Option value="">请选择</Option>
									<Option v-for="item in liveNumberList" :value="item" :key="item">{{item}}</Option>
								</Select>
								<Tooltip v-if="logList.checkinNum" style="height:30px;display:inline-block;width:50px;margin-left:5px;float:left" placement="top">
										<span class="red">更新记录</span>
										<div slot="content">
												<p v-for="(item,index) in logList.checkinNum" :key="index">
													{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
												</p>
										</div>
								</Tooltip>
								<!-- <span>更新记录</span> -->
         			</FormItem>
						</Col>
						<Col span="10">
							<FormItem label="意向户型" prop="houseType">
								<Select style="width:210px" v-model="formData.houseType">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in houseTypeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<Tooltip v-if="logList.houseType" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
									<span class="red">更新记录</span>
									<div slot="content">
										<p v-for="(item,index) in logList.houseType" :key="index">
											{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
										</p>
									</div>
								</Tooltip>
         			</FormItem>
						</Col>
					</Row>
					<Row  :gutter="10">
        <Col span="10">
         <FormItem label="意向面积" prop="intentionArea">
						<Select style="width:210px" v-model="formData.intentionArea">
							<Option value="">请选择</Option>
							<Option v-for="(item,index) in intentionAreaList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
						</Select>
						<Tooltip v-if="logList.intentionArea" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
							<span class="red">更新记录</span>
							<div slot="content">
								<p v-for="(item,index) in logList.intentionArea" :key="index">
									{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
								</p>
							</div>
						</Tooltip>
					</FormItem>
        </Col>
        <Col span="10">
          <FormItem label="意向居住地点" prop="intentionAddress">
            <location ref="intentionAddress" :id="'intentionAddress'"></location>


            <!--           	<Cascader style="width:210px;float:left" :data="regionList" trigger="hover" v-model="formData.intentionAddressArr"></Cascader>-->
						 <!-- <Tooltip v-if="logList.intentionAddress" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
							<span class="red">更新记录</span>
							<div slot="content">
								<p v-for="(item,index) in logList.intentionAddress" :key="index">
									{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
								</p>
							</div>
						</Tooltip> -->
					</FormItem>
        </Col>
				</Row>
				<Row>
					<Col span="10">
						<FormItem label="期望租住时长" prop="rentType">
							<Select style="width:140px" v-model="formData.rentType" @on-change="changeRentPeriod">
								<Option :value=0>请选择</Option>
								<Option :value=1>长租</Option>
								<Option :value=2>短租</Option>
							</Select>
							<InputNumber v-if="formData.rentType" v-model="formData.rentLength" :max="25" :min="0" style="width: 50px;"></InputNumber>
							<span v-if="formData.rentType && formData.rentType==1">年</span>
							<span v-if="formData.rentType &&formData.rentType==2">月</span>
							<Tooltip v-if="logList.rentType||logList.rentLength" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
								<span class="red">更新记录</span>
								<div slot="content">
									<p v-if="logList.rentType" v-for="(item,index) in logList.rentType" :key="index">
										{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
									</p>
									<p v-if="logList.rentLength" v-for="(item,index) in logList.rentLength" :key="index+'s1'">
										{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
									</p>
								</div>
						</Tooltip>
						</FormItem>
        	</Col>
					<Col span="10" v-if="formData.rentType &&formData.rentType==2">
						<FormItem label="短租用途" prop="shortRentDes">
							<Select style="width:210px;" v-model="formData.shortRentDes">
								<Option value="">请选择</Option>
								<Option v-for="(item,index) in shortRentDesList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
							</Select>
							<!-- <Tooltip v-if="logList.shortRentDes" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
							<span class="red">更新记录</span>
							<div slot="content">
								<p v-for="(item,index) in logList.shortRentDes" :key="index">
									{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
								</p>
							</div>
						</Tooltip> -->
						</FormItem>

					</Col>
      	</Row>
      <Row :gutter="10" >

        <Col span="10">
          <FormItem label="通勤方式" prop="commutingMode">
						<Select style="width:210px" v-model="formData.commutingMode">
							<Option value="">请选择</Option>
							<Option v-for="(item,index) in commutingModeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
						</Select>
						<Tooltip v-if="logList.commutingMode" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
							<span class="red">更新记录</span>
							<div slot="content">
								<p v-for="(item,index) in logList.commutingMode" :key="index">
									{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
								</p>
							</div>
						</Tooltip>
					</FormItem>
        </Col>
        <Col span="12">
          <FormItem label="期望通勤时长" prop="">
            <Select  v-model="formData.commutingDuration"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in commutingDurationList" :value="item.value" :key="item.value+'keyB'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
					<h4>当前住房情况</h4>
					<Row :gutter="10">
						<Col span="10">
							<FormItem  label="当前入住状态" prop="currentCheckinStatus">
								<Select style="float:left" :class="['width100',{'width80':formData.currentCheckinStatus==99}]" v-model="formData.currentCheckinStatus">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in currentCheckinStatusList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<Col span="4" style="width:200px" v-if="formData.currentCheckinStatus==99">
									<Input placeholder="请填写入住状态" v-model="formData.currentCheckinMsg"></Input>
								</Col>
							</FormItem>
						</Col>

						<Col span="10">
							<FormItem label="找房需求紧急度" prop="intentionLevel">
								<Select style="width:210px" v-model="formData.intentionLevel">
									<Option value="">请选择</Option>
									<Option v-for="(item,index) in intentionLevelList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
								</Select>
								<!-- <Tooltip v-if="logList.intentionLevel" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
								<span class="red">更新记录</span>
								<div slot="content">
									<p v-for="(item,index) in logList.intentionLevel" :key="index">
										{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
									</p>
								</div>
							</Tooltip> -->
							</FormItem>
						</Col>
					</Row>
					<Row :gutter="10">
						<Col span="10">
							<FormItem label="当前居住房屋到期时间" prop="rentEndTime">
								<DatePicker style="width:100%" v-model="formData.rentEndTime"  split-panels  format="yyyy-MM-dd" placeholder="期望入住时间"></DatePicker>
							</FormItem>
						</Col>
							<Col :span="formData.residence===0?6:10">
							<FormItem label="当前居住地点" prop="residence">
                <location ref="residenceaddress" :id="'residenceupdate'"></location>


                <!--           			<Cascader style="width:210px;float:left" :data="regionList" trigger="hover" v-model="formData.residenceArr"></Cascader>-->
								 <!-- <Tooltip v-if="logList.residence" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
								<span class="red">更新记录</span>
								<div slot="content">
									<p v-for="(item,index) in logList.residence" :key="index">
										{{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
									</p>
								</div>
							</Tooltip> -->
							</FormItem>
						</Col>
						<Col span="4" v-if="formData.residence === 0">
							<Input placeholder="请填写当前居住地点" v-model="formData.residenceDesc" ></Input>
						</Col>
					</Row>
				</Form>

			</Tab-pane>
    </Tabs>
  </Modal>
</template>

<script>
import {getNationEnum,getCityEnumByNationCode,getBusinessEnums,updateCustomer,getCustomerPortrait,getAreaRegionByProjectFid,getCustomerPortraitLog} from 'api/business'
import {formatDateTime} from "../../../../utils/format"
import Location from 'components/Location/index'

export default {
  components:{
    Location

  },
  props:{
		n:{
			type:Number,
			default:0
		},
		uid:{
			type:String,
			default:''
		},
		projectFid:{
			type:String,
			default:''
		}
	},
	data(){
		const validates = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择出生日期'));
      } else{
        callback();
      }
		};
		const validatecontactPhone = (rule, value, callback) => {
			let pattern = /^\d+$/
			if (!pattern.test(value)) {
				callback(new Error('输入正确的联系方式'));
			}
			callback();
		};
		return{
      jobTradedata:[],
      jobTrade:[],
      commutingDurationList:[],
			formData:{},
			regionList:[],
			// houseTypeList:[],
			jiguanList:[],
			loading:true,
			show:false,
			formRules: {
				// realName: [{required: true, message: '请输入客户姓名', trigger: 'blur', type: 'string'}],
				// customerSex:[{required: true, message: '请选择性别', trigger: 'change', type: 'number'}],
				// customerBirthday:[{required: true, trigger: 'change', validator: validates}],
			},
			nationList:[],
			customerEduList:[],
			budgetRangeList:[],
			intentionAreaList:[],
			salaryRangeList:[],
			currentCheckinStatusList:[],
			channelList:[],
			houseTypeList:[],
			commutingModeList:[],
			impressionList:[],
			liveNumberList:[],
			currentStatusList:[],
			intentionLevelList:[],
			idTypeList:[],
			logList:{
				checkinNum:[]
			},
			customerBirthday:'',
			age:0,
		}
	},
	watch:{
		n(){
      this.$refs['formData'].resetFields();
			this.show = true
			this.formData.workAddressArr = []
			this.formData.intentionAddressArr= []
			this.formData.residenceArr=[]
			this.customerBirthday = ''
			this.age = 0;
			this.jobTradedata=[]

      this.$refs['workaddress'].resetData()
      this.$refs['residenceaddress'].resetData()
      this.$refs['intentionAddress'].resetData()

			this.getDetails(this.uid);
			this.getRegion(this.projectFid)
			this.getLogs(this.uid);
		},
		customerBirthday(val){
			let bir = new Date(val).getFullYear();
			this.age = new Date().getFullYear() - bir
		}
	},
	created(){
		this.getLists();
	},
	methods:{
		getDetails(uid){
			getCustomerPortrait({uid:uid}).then( res=>{
			  if(!res.data){
			    return

        }
				this.formData = res.data;
				if(this.formData.customerBirthday){
					this.customerBirthday = new Date(this.formData.customerBirthday);
				}
				this.formData.workAddressArr = [this.formData.workAddressCity,this.formData.workAddressArea,this.formData.workAddress];
				this.formData.intentionAddressArr = [this.formData.intentionAddressCity,this.formData.intentionAddressArea,this.formData.intentionAddress];
				this.formData.residenceArr = [this.formData.residenceCity,this.formData.residenceArea,this.formData.residence];

				let data=res.data

       this.$refs['workaddress'].setData(
         {
           cityCode:data['workAddressCity']   ,
           regionCode:data['workAddressArea'],
           address: data['workAddressDesc'],
           lon:data['workAddressLon'],
           lat:data['workAddressLat'],

         }
       )

        this.$refs['residenceaddress'].setData(
          {
            cityCode:data['residenceCity'],
            regionCode:data['residenceArea'],
            address:data['residenceDesc'],
            lon:data['residenceLon'],
            lat: data['residenceLat']

          }
        )

       this.$refs['intentionAddress'].setData({
         cityCode:data['intentionAddressCity'],
         regionCode:data['intentionAddressArea'],
         address:data['intentionAdsMsg'],
         lon:data['intentionAddressLon'],
         lat: data['intentionAddressLat']
       })


        //行业、方向
        if(data.jobTrade&&data.jobTradeDirection){
         this.jobTradedata=[data.jobTrade,data.jobTradeDirection]

        }


			})
		},
		getLogs(uid){
			getCustomerPortraitLog({uid:uid}).then( res => {
				this.logList = res.data;
				console.log(this.logList)
			})
		},
		getLists(){
			getNationEnum().then( res=>{
				this.nationList = res.data;
			})
			getBusinessEnums().then( res=>{
			  if(!res.data){
			    return

        }
			  this.jobTrade=res.data.jobTrade

			  this.commutingDurationList=res.data.commutingDuration


				this.salaryRangeList = res.data.salaryRange;
				this.intentionAreaList = res.data.intentionArea;
				this.budgetRangeList = res.data.budgetRange;
				this.customerEduList = res.data.customerEdu;
				this.currentStatusList = res.data.currentStatus;
				this.currentCheckinStatusList = res.data.currentCheckinStatus;
				this.channelList = res.data.channel;
				this.houseTypeList = res.data.houseType;
				this.commutingModeList = res.data.commutingMode;
				this.impressionList = res.data.impression;
				this.intentionLevelList = res.data.intentionLevel;
				this.shortRentDesList = res.data.shortRentDes;
				this.idTypeList = res.data.idType;
				let liveNumberList = res.data.liveNumber;
        for(var i = 1 ; i <= liveNumberList; i++){
          this.liveNumberList.push(i)
        }
			})

		},
		getJiguan(value){
			getCityEnumByNationCode({nationCode:value})
			.then( res => {
				this.jiguanList = res.data;
			})
		},
		changeRentPeriod(value) {
			if(value==1 && this.formData.rentLength==-1) {
				this.formData.rentLength = null
			}else if(value==2 && this.formData.rentLength==-1){
				this.formData.rentLength = null
			}else if(value == 0) {
				this.formData.rentLength = null
				this.formData.rentType = 0
			}
		},
		getRegion(fid){
			getAreaRegionByProjectFid({projectFid:fid}).then( res=>{
				this.regionList = res.data;
			})
		},
		formTime(){
      return data?formatDateTime(data, false):''
		},
		changeLoading() {
			this.loading = false;
			this.$nextTick(() => {
				this.loading = true
			})
		},
		ok(){
			this.$refs['formData'].validate( bool => {
        if(bool){
					if(this.formData.workAddressArr[0]){
						this.formData.workAddressCity = this.formData.workAddressArr[0]
					}
					if(this.formData.workAddressArr[1]){
						this.formData.workAddressArea = this.formData.workAddressArr[1]
						this.formData.workAddress = ''
					}
					if(this.formData.workAddressArr[2]){
						this.formData.workAddress = this.formData.workAddressArr[2]
					}
					if(this.formData.intentionAddressArr[0]){
						this.formData.intentionAddressCity = this.formData.intentionAddressArr[0]
					}
					if(this.formData.intentionAddressArr[1]){
						this.formData.intentionAddressArea = this.formData.intentionAddressArr[1]
						this.formData.intentionAddress = ''
					}
					if(this.formData.intentionAddressArr[2]){
						this.formData.intentionAddress = this.formData.intentionAddressArr[2]
					}

					if(this.formData.residenceArr[0]){
						this.formData.residenceCity = this.formData.residenceArr[0]
					}
					if(this.formData.residenceArr[1]){
						this.formData.residenceArea = this.formData.residenceArr[1]
						this.formData.residence = ''
					}
					if(this.formData.residenceArr[2]){
						this.formData.residence = this.formData.residenceArr[2]
					}


					if(this.formData.currentStatus == 99&&!this.formData.currentStatusMsg){
						this.$Message.info('请输入当前状态')
						this.changeLoading();
						return false
					}
					if(this.formData.currentStatus!=99){
						this.formData.currentStatusMsg = ''
					}
					if(this.formData.channel == 99&&!this.formData.channelMsg){
						this.$Message.info('请输入获知自如寓渠道')
						this.changeLoading();
						return false
					}
					if(this.formData.channel!=99){
						this.formData.channelMsg = ''
					}
					if(this.formData.impression == 99&&!this.formData.impressionMsg){
						this.$Message.info('请输入自如寓印象')
						this.changeLoading();
						return false
					}
					if(this.formData.impression!=99){
						this.formData.impressionMsg = ''
					}
					if(this.formData.currentCheckinStatus == 99&&!this.formData.currentCheckinMsg){
						this.$Message.info('请输入当前入住状态')
						this.changeLoading();
						return false
					}
					if(this.formData.currentCheckinStatus!=99){
						this.formData.currentCheckinMsg = ''
					}

					if(this.formData.rentType&&!this.formData.rentLength){
						this.$Message.info('请输入期望租住时长')
						this.changeLoading();
						return false
					}
					this.formData.customerBirthday = this.customerBirthday;
					this.formData.uid = this.uid;

					let data={}
          //地点调整
          let workdata=this.$refs['workaddress'].data
          data['workAddressCity']=workdata.cityCode
          data['workAddressArea']=workdata.regionCode
          data['workAddressDesc']=workdata.address
          data['workAddressLon']= workdata.lng
          data['workAddressLat']= workdata.lat

          let  residenceaddress=this.$refs['residenceaddress'].data
          data['residenceCity']=residenceaddress.cityCode
          data['residenceArea']=residenceaddress.regionCode
          data['residenceDesc']=residenceaddress.address
          data['residenceLon']= residenceaddress.lng
          data['residenceLat']= residenceaddress.lat

          let intentionaddress=this.$refs['intentionAddress'].data
          data['intentionAddressCity']=intentionaddress.cityCode
          data['intentionAddressArea']=intentionaddress.regionCode
          data['intentionAdsMsg']=intentionaddress.address
          data['intentionAddressLon']= intentionaddress.lng
          data['intentionAddressLat']= intentionaddress.lat

          //行业、方向
          if(this.jobTradedata&&this.jobTradedata.length){
            data['jobTrade']=this.jobTradedata[0]
            data['jobTradeDirection']=this.jobTradedata[1]

          }

          updateCustomer({...this.formData,...data})
          .then( res => {
            if(res.code === 0){
              this.$Message.success('保存成功')
              this.$emit('done')
            } else{
              this.$Message.error('保存失败')
						}
          })
          .catch( error => {
            this.$Message.error('保存失败')
          })
          .finally(()=>{
            this.show = false
          })
        }
         else{
          this.changeLoading();
        }
      })
		},
		cancel(){

		}
	}
}
</script>

<style scoped>
  .personas{
    /*padding-bottom: 100px;*/
  }
h4{
	margin-bottom:20px;
}
.wid120{
	width:120px;
}
.wid274{
	width:274px;
}
.wid100{
	width:100%;
}
.red{
	color: #CFA868;
  width: 100px;
  display: inline-block;
}
.width210{
	width: 210px;
	margin-right: 5px;
}
.width80{
	width: 80px;
}
.tip{
	height:30px;display:inline-block;width:50px;
}
</style>
<style>
 .personas .ivu-tooltip .ivu-tooltip-rel{
	height: 30px;
	line-height: 26px!important;
}
.personas .ivu-tabs{
	overflow: unset!important;
}

</style>
